import { Component, Input, OnInit } from "@angular/core";

@Component({
  selector: "app-progress-steps",
  templateUrl: "./progress-steps.component.html",
  styleUrls: ["./progress-steps.component.scss"],
})
export class ProgressStepsComponent implements OnInit {

  @Input() numOfSteps = 4;
  @Input() currentStep = 1;
  @Input() mode = "add";

  constructor() { }

  ngOnInit() {}

  getClasses(step) {
    let classList = "step";
    if (this.mode === "add") {
      if (step === this.currentStep) {
        classList += " current";
      } else if (step < this.currentStep) {
        classList += " completed";
      }
    } else if (this.mode === "edit") {
      if (step !== this.currentStep) {
        classList += " completed";
      } else {
        classList += " current";
      }
    }
    return classList;
  }
}
